<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Müşteri Emaili Oluştur</h4>
              <p class="card-category">Müşteriye ait bir hesap, tanıtım maili bu emaile gidecektir.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="email" label="Email" placeholder="Email" v-model="payload.mail">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Şirket İsmi" placeholder="Şirket İsmi" v-model="payload.companyName">
                  </base-input>
                </div>
              </div>


              <label>Grup Seçimi</label>

              <div class="row" v-for="group of mailGroups" :key="group._id">
                <div class="col-md-4">
                  <label>{{ group.title }}</label>
                  <base-checkbox @click="selectGroup(group._id)" type="text"
                    :checked="payload.mailGroup.includes(group._id)"
                    :disabled="group.isSpecialGroup && isSpecialGroupSelected && selectedSpecialGroup._id !== group._id">
                  </base-checkbox>
                </div>
              </div>






              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Aktif Mi?</label>
                  <base-checkbox type="text" label="Host" placeholder="Host" v-model="payload.isActive">
                  </base-checkbox>
                </div>
              </div>



              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewFromMail">
                  Oluştur
                </button>
              </div>
              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        mail: "",
        companyName: "",
        isActive: true,
        mailGroup: [],
      },
      isSpecialGroupSelected: false,
      selectedSpecialGroup: null,
      mailGroups: []
    }
  },
  mounted() {
    this.getMailGroups();
  },
  methods: {
    createNewFromMail() {
      CollectionService.postWidthAuth('mail', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Mail Oluşturuldu")
          this.$router.push(`/admin/mails`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getMailGroups() {

      CollectionService.getCollection('mailGroup').then((res) => {
        if (res.success == true) {
          this.mailGroups = res.mailGroups;
          console.log(this.mailGroups)
        } else {
          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    selectGroup(_id) {
      const group = this.mailGroups.find(x => x._id == _id);



      if (!this.payload.mailGroup.includes(_id)) {
        this.payload.mailGroup.push(_id);
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = true;
          this.selectedSpecialGroup = group;
        }

      } else {
        this.payload.mailGroup = this.payload.mailGroup.filter(x => x != _id)
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = false;
          this.selectedSpecialGroup = null;
        }
      }
    }
  }
}
</script>
<style></style>